<app-onb-moldura passo="pagamento" [estado]="estado" subtitulo="Já deixamos o comum ligado. Desligue o que você não aceita.">

  <p class="onb-sub" *ngIf="carregando">Carregando as formas de pagamento…</p>
  <div class="onb-erro" *ngIf="erro">{{ erro }} <button type="button" class="onb-btn onb-btn--link" (click)="carregue()">Tentar de novo</button></div>

  <ng-container *ngIf="!carregando && grupos.length">
    <div class="onb-grupo-rot">Na entrega ou na retirada</div>
    <div class="onb-grupo" id="onb-pagamentos">
      <ng-container *ngFor="let g of grupos">
        <div class="onb-linha">
          <span class="onb-ic onb-ic--pagamento"><i [class]="icone(g)"></i></span>
          <div class="onb-tx">
            <b>{{ g.nome }}</b>
            <span>{{ g.detalhe }}<ng-container *ngIf="g.formas.length > 1"> {{ g.formas.length }} bandeiras.</ng-container></span>
            <span class="pp-erro" *ngIf="g.erro">{{ g.erro }}</span>
          </div>
          <i class="fas fa-spinner fa-spin pp-girando" *ngIf="g.salvando"></i>
          <label class="onb-sw">
            <input type="checkbox" [id]="'onb-pag-' + g.chave" [ngModel]="ligado(g)" (ngModelChange)="alterne(g, $event)"
                   [attr.aria-label]="g.nome"><span></span>
          </label>
        </div>
        <div class="onb-campos" *ngIf="g.pix">
          <div class="onb-campo">
            <label [for]="'onb-chave-' + g.chave">Sua chave Pix</label>
            <input class="onb-inp" [id]="'onb-chave-' + g.chave" [(ngModel)]="g.chavePix" (blur)="salveChavePix(g)" (keyup.enter)="salveChavePix(g)"
                   placeholder="CNPJ, celular, e-mail ou chave aleatória" autocomplete="off">
          </div>
        </div>
      </ng-container>
    </div>
    <p class="onb-nota">Pix com confirmação automática, sem conferir comprovante, você ativa depois em Pagamentos online.</p>
  </ng-container>

  <div class="onb-rodape">
    <span class="onb-dica">{{ pixSemChave ? 'Sem chave o cliente não vê a opção Pix' : (!algumLigado ? 'Ligue ao menos uma forma' : '') }}</span>
    <a class="onb-btn onb-btn--link" routerLink="/admin/comecar">Fazer depois</a>
    <button type="button" class="onb-btn onb-btn--pri onb-btn--grande" (click)="confirme()">
      {{ confirmando ? 'Salvando…' : 'Está tudo certo' }}
    </button>
  </div>
</app-onb-moldura>
